import { Sparkles } from "lucide-react";

const STORY = [
  { label: "Uma peça falha,", small: "um rolamento se desgasta" },
  { label: "uma esteira para,", small: "a produção interrompe" },
  { label: "um motor desliga,", small: "um turno inteiro atrasa" },
  { label: "uma operação inteira", small: "deixa de produzir" },
];

export const PieceStory = () => {
  return (
    <section
      id="piece-story"
      data-testid="piece-story"
      className="relative py-24 lg:py-32 bg-white overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-32 reveal">
            <div className="flex items-center gap-2 text-gold mb-6">
              <Sparkles className="w-4 h-4" />
              <span className="tracking-eyebrow">Big Idea</span>
            </div>
            <h2 className="font-display text-5xl lg:text-6xl font-bold text-navy leading-[0.98] tracking-[-0.03em]">
              Tudo começa
              <br />
              com uma <span className="text-gold italic">peça</span>.
            </h2>
            <div className="divider-gold mt-8 mb-8" />
            <p className="text-lg text-slate-600 leading-relaxed max-w-md">
              Uma indústria inteira depende de pequenos componentes. Quando um deles falha,
              todo o resto para. É nesse momento que a{" "}
              <span className="text-navy font-semibold">Imporparts</span> faz a diferença.
            </p>
          </div>

          <div className="lg:col-span-7 space-y-4">
            {STORY.map((s, i) => (
              <div
                key={i}
                className="reveal card-lift group flex items-baseline gap-6 border border-slate-200 rounded-2xl p-6 lg:p-8 bg-white"
                data-testid={`piece-story-item-${i}`}
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                <div className="font-display text-4xl lg:text-5xl font-bold text-slate-200 group-hover:text-gold transition-colors w-16 shrink-0">
                  0{i + 1}
                </div>
                <div>
                  <div className="font-display text-2xl lg:text-3xl font-semibold text-navy leading-tight">
                    {s.label}
                  </div>
                  <div className="text-slate-500 mt-1 text-base">{s.small}</div>
                </div>
              </div>
            ))}

            <div
              className="reveal mt-10 rounded-2xl p-8 lg:p-10 bg-navy text-white relative overflow-hidden grain"
              data-testid="piece-story-conclusion"
            >
              <div
                className="absolute -right-16 -bottom-16 w-72 h-72 rounded-full blur-3xl opacity-40"
                style={{ background: "radial-gradient(closest-side, rgba(184,134,58,0.7), transparent)" }}
                aria-hidden
              />
              <div className="tracking-eyebrow text-gold mb-3 relative">Nossa missão</div>
              <div className="font-display text-3xl lg:text-4xl font-semibold leading-tight relative">
                Impedir que uma operação pare.
              </div>
              <p className="mt-4 text-white/75 relative max-w-xl">
                A Imporparts entrega soluções corporativas e industriais — engenharia de suprimentos, nacionalização de componentes
                nacionais e internacionais para entregar rapidamente o componente crítico
                que mantém sua empresa produzindo.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
